import { useEffect } from "react";

const SITE = "Faithful Store";
const DEFAULT_DESC = "Christian ebooks, guided prayer journals, scripture stickers and Bible studies — instant digital downloads to help you walk boldly in faith every day.";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path, noindex = false, jsonLd = null, image = null }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Christian Ebooks, Journals & Stickers`;
    const desc = (description || DEFAULT_DESC).slice(0, 160);
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", jsonLd?.["@type"] === "Product" ? "product" : "website");
    upsertMeta("property", "og:site_name", SITE);
    upsertMeta("name", "twitter:card", "summary_large_image");
    if (image) upsertMeta("property", "og:image", image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.setAttribute("rel", "canonical"); document.head.appendChild(canonical); }
    canonical.setAttribute("href", url);
    let ld = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!ld) { ld = document.createElement("script"); ld.id = "seo-jsonld"; ld.type = "application/ld+json"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) ld.remove();
  }, [title, description, path, noindex, image, JSON.stringify(jsonLd)]); // eslint-disable-line
}
